import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FilterModal from 'components/FilterModal'
import Button from 'components/common/Button/Button'
import Icon from 'components/common/Icon/Icon'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'
import { FilterGroup } from 'components/common/Filters/FilterGroup'
import { filterProps } from 'helpers/utils'
import CustomPriceRangeForm from '../CustomPriceRangeForm'
import SortByForm from '../../SortByForm'
import { PRICE_PER_TIRE_NAME } from '../../constants'
import OEFilterButton from './../OEFilterButton'

const FiltersModal = ({
  navigation,
  sortOptions,
  selectedFilters,
  filterItems,
  resetFilters,
  handleFilterModalShow,
  handleFilterModalHide
}) =>
  <Fragment>
    <CustomOeFilterButton />
    <FilterButton filter full stacked onClick={ handleFilterModalShow }>
      <Icon data-at-filter-button-icon asset="icon-filter-white" margin="-3px 10px 0 0" />
      <span data-at-filter-button-label>Filter & Sort Results</span>
    </FilterButton>
    <FilterModal onSubmit={ handleFilterModalHide }>
      <FilterBreadcrumbs
        selectedFilters={ selectedFilters }
        onFilterClear={ resetFilters }
        onFilterRemove={ filterItems } />
      <SortByForm sortOptions={ sortOptions } />
      <FilterList>
        {
          navigation.map(({ name, refinements = []}) =>
            <li key={ name }>
              <FilterGroup
                title={ name }
                refinements={ refinements }
                onChange={ filterItems }>
                {
                  name === PRICE_PER_TIRE_NAME &&
                  <CustomPriceRangeForm refinements={ refinements } />
                }
              </FilterGroup>
            </li>
          )
        }
      </FilterList>
    </FilterModal>
  </Fragment>

FiltersModal.propTypes = {
  filterItems: PropTypes.func,
  handleFilterModalHide: PropTypes.func,
  handleFilterModalShow: PropTypes.func,
  navigation: PropTypes.arrayOf(PropTypes.shape()),
  resetFilters: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(PropTypes.shape()),
  sortOptions: PropTypes.arrayOf(PropTypes.shape())
}

export default FiltersModal

const FilterButton = styled(props => <Button { ...filterProps(props, ['filter']) } />)`
  transform: none;
  line-height: 26px;
  padding: 6px 24px;
`

const FilterList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  margin-top: 30px;
`

const CustomOeFilterButton = styled(OEFilterButton)`
  margin-bottom: 15px;
`

